import { FC } from 'react';

import { Box, Divider, Typography } from '@mui/material';

import { INotificationGroup } from '@/models';

import { NotificationItem } from './NotificationItem';

interface NotificationGroupProps {
  group: INotificationGroup;
  onNotificationClick: () => void;
}

export const NotificationGroup: FC<NotificationGroupProps> = ({
  group,
  onNotificationClick,
}) => {
  return (
    <Box>
      <Divider />
      <Typography
        variant="body1"
        fontWeight={500}
        color="text.primary"
        sx={{ px: 3, py: 2, fontSize: '1rem' }}
      >
        {group.title}
      </Typography>
      <Box>
        {group.notifications
          .filter(
            (notification) =>
              notification.recordType === 'skydio-email' ||
              !notification.message.includes('deleted'),
          )
          .map((notification) => (
            <NotificationItem
              key={notification._id}
              notification={notification}
              onNotificationClick={onNotificationClick}
            />
          ))}
      </Box>
    </Box>
  );
};
